__turbopack_context__.v({
  "className": "neuehaasgroteskfont_2aef66a3-module__d41xka__className",
  "variable": "neuehaasgroteskfont_2aef66a3-module__d41xka__variable",
});
